import { useMemo } from "react";
import useNewDataFetcher from "../../../../Hooks/newUseDataFetcher";
import GraphTable from "../../../../Components/GraphTable";
import SubheaderTimePeriod from "../../../../Components/SubheaderTimePeriod";
import { formatNumber } from "../../../../Utilities/formatting";

function OverTime() {
  const dataURL = "/api/v1/result/bookings/over-time"
  const { data, dateRange, filterTypes, filters, isReady } = useNewDataFetcher({
    endPoint: dataURL,
  });

  const revenue = useMemo(() => {
    if (!data) return 0;
    let revenue = data.data.reduce((acc, cur) => {
      acc += cur.flatFee;
      return acc;
    }, 0);
    return revenue;
  }, [data]);

  return (
    <GraphTable data={data} dateRange={dateRange} interval={dateRange.interval} filterTypes={filterTypes} filters={filters} isReady={isReady} dataURL={dataURL}>
      <h1 className="page-heading">Revenue over time</h1>
      <h2 className="page-subheading">
        $<span className="page-data">{formatNumber(revenue)}</span> booked <SubheaderTimePeriod data={dateRange} />
      </h2>
    </GraphTable>
  );
}

export default OverTime;
